import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import CallOut from '../components/CallOut';
import { PlanTier, UserType } from '../graphql/generated/graphql';
import AdminListButton from '../user/AdminListButton';
import Link from '../utils/router/Link';

interface InvitationSeatCalloutProps {
  guestLimitReached: boolean;
}

const InvitationSeatCallout = ({
  guestLimitReached,
}: InvitationSeatCalloutProps) => {
  const isAdmin = useAppSelector(
    (state) => state.session.user.type === UserType.Admin,
  );
  const planTier = useAppSelector(
    (state) => state.session.organization.planTier,
  );

  if (planTier === PlanTier.Free) {
    if (isAdmin) {
      return (
        <CallOut variant="danger">
          Your team has reached the seat limit for our free plan. Please upgrade
          to a paid plan to add additional teammates.
        </CallOut>
      );
    }
    return (
      <CallOut variant="danger">
        Your team has reached the seat limit for our free plan. Please{' '}
        <AdminListButton variant="link">contact an admin</AdminListButton> to
        add additional teammates.
      </CallOut>
    );
  }

  if (guestLimitReached) {
    if (isAdmin) {
      return (
        <CallOut variant="danger">
          Your team has reached the seat limit for your plan. Please{' '}
          <Link to="mailto:support@slab.com">contact support</Link> to add
          additional teammates.
        </CallOut>
      );
    }
    return (
      <CallOut variant="danger">
        Your team has reached the seat limit for your plan. Please{' '}
        <AdminListButton variant="link">contact an admin</AdminListButton> to
        add additional teammates.
      </CallOut>
    );
  }
  if (isAdmin) {
    return (
      <CallOut variant="warning">
        Your team has reached the seat limit for your plan. You can still invite
        guests, but please{' '}
        <Link to="mailto:support@slab.com">contact support</Link> to add
        additional teammates.
      </CallOut>
    );
  }
  return (
    <CallOut variant="warning">
      Your team has reached the seat limit for your plan. You can still invite
      guests, but please{' '}
      <AdminListButton variant="link">contact an admin</AdminListButton> to add
      additional teammates.
    </CallOut>
  );
};

export default InvitationSeatCallout;
